import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { WeightUnit } from '../../types/weightUnit';

const api = generateApiClient();

export const getWeightUnitsApi = async (query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`WeightUnits${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createWeightUnitsApi = async (weightUnits: WeightUnit): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`WeightUnits`, weightUnits);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateWeightUnitsApi = async (weightUnitId: number, weightUnits: WeightUnit): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`WeightUnits/${weightUnitId}`, weightUnits);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
